// @ts-strict-ignore
import keyBy from 'lodash/keyBy';

import {customPropertyClientLegacy} from 'common/report/queries/app-api/custom-properties-client';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import type {CustomProperty} from 'common/types/reports/query';

import {Store} from './store';

export enum CustomPropertyResourceType {
  Events = `events`,
  People = `people`,
}

export interface CustomProperties {
  [customPropertyId: string]: CustomProperty;
}

export const customPropertiesStore = new Store<CustomProperties>({
  apiClient: customPropertyClientLegacy,
  name: `custom-properties`,
  transform: {
    index: (response) => keyBy(response.results, `customPropertyId`),
    update: (response) => {
      const results = response.results;
      return {k: results && results.customPropertyId, v: results};
    },
  },

  defaultValue: {},
});

export function fetchCustomProperties({callback = null}: {callback?: () => void} = {}): Promise<void> {
  if (callback) {
    customPropertiesStore.subscribe(callback);
  }

  return customPropertiesStore.fetch({
    projectId: getProjectId(),
    workspaceId: getWorkspaceId(),
  });
}
